module.exports={
    "api": {
        "url": "https://api.ecogate.com",
        "port": 443,
        "secure": true
    }
}
